module.exports = __webpack_public_path__ + "static/img/tx5-b.7341d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/tx5-b.png
// module id = jC5J
// module chunks = 1